import React from 'react';
import { Table, Button } from 'semantic-ui-react';
import { useDeleteUnitTypes } from '~/unit-types';
import { sortBy } from 'lodash';
import Dayjs from 'dayjs';


const UnitTypesTable = props => {

    const {
        allUnitTypesWithRate,
        setInitialValues,
        setUnitTypesModalOpen,
        propertyId
    } = props;

    const allUnitTypesSorted = sortBy(allUnitTypesWithRate, 'name');

    const { mutate: deleteUnitTypes } = useDeleteUnitTypes();

    return (
        <Table columns={7} fixed size='small'>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell width='2'> Name </Table.HeaderCell>
                    <Table.HeaderCell width='1'> Bedroom </Table.HeaderCell>
                    <Table.HeaderCell width='1'> Base Price </Table.HeaderCell>
                    <Table.HeaderCell width='1'> Growth Rate </Table.HeaderCell>
                    <Table.HeaderCell width='2'> Last Market Date Change </Table.HeaderCell>
                    <Table.HeaderCell width='1'> New Price </Table.HeaderCell>
                    <Table.HeaderCell width='3' textAlign='right'> Actions </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {allUnitTypesSorted.map((unit, i) => (
                    <Table.Row key={`unit-${i}`}>
                        <Table.Cell content={unit.name} />
                        <Table.Cell content={unit.bedroom} />
                        <Table.Cell content={unit.base_price} />
                        <Table.Cell content={unit.growth_rate} />
                        <Table.Cell content={(unit.date) ? Dayjs(unit.date).format('MM/DD/YYYY') : ''} />
                        <Table.Cell content={unit.new_price} />
                        <Table.Cell textAlign='right'>
                            <Button.Group>
                                <Button
                                    compact
                                    content='Edit'
                                    icon='edit'
                                    onClick={() => {
                                        setInitialValues(unit);
                                        setUnitTypesModalOpen(true);
                                    }}
                                />
                                <Button
                                    compact
                                    negative
                                    content='Delete'
                                    icon='delete'
                                    onClick={() => {
                                        deleteUnitTypes(unit.id);
                                    }}
                                />
                            </Button.Group>
                        </Table.Cell>
                    </Table.Row>
                ))}
            </Table.Body>
            <Table.Footer>
                <Table.Row>
                    <Table.HeaderCell colSpan='7' textAlign='right'>
                        <Button
                            compact
                            primary
                            content='New Unit Type'
                            onClick={() => {
                                setInitialValues({ property_id: propertyId });
                                setUnitTypesModalOpen(true);
                            }}/>
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Footer>
        </Table>
    );
};

export default UnitTypesTable;
